import React from 'react';
import { Grid, Container } from '@material-ui/core';
import { node, string, bool, number } from 'prop-types';

const DefaultContainer = ({
  children,
  justify,
  alignItems,
  direction,
  spacing,
  wrap,
  noPadding,
  maxWidth,
  ...props
}) => (
  <div {...props}>
    {noPadding ? (
      <Grid
        container
        spacing={spacing}
        direction={direction}
        justify={justify}
        alignItems={alignItems}
        wrap={wrap}
      >
        {children}
      </Grid>
    ) : (
      <Container maxWidth={maxWidth}>
        <Grid
          container
          spacing={spacing}
          direction={direction}
          justify={justify}
          alignItems={alignItems}
          wrap={wrap}
        >
          {children}
        </Grid>
      </Container>
    )}
  </div>
);

DefaultContainer.propTypes = {
  children: node,
  justify: string,
  alignItems: string,
  direction: string,
  noPadding: bool,
  spacing: number,
  wrap: string,
  maxWidth: string,
};

DefaultContainer.defaultProps = {
  children: null,
  justify: null,
  alignItems: null,
  direction: null,
  noPadding: false,
  spacing: 0,
  wrap: 'wrap',
  maxWidth: 'lg',
};

export default DefaultContainer;
